import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "@/components/ui/button";

interface TagInstanceNavigationButtonProps {
  direction: "previous" | "next";
  tagLabel: string;
  disabled: boolean;
  onClick: () => void;
}

export function TagInstanceNavigationButton({
  direction,
  tagLabel,
  disabled,
  onClick,
}: TagInstanceNavigationButtonProps) {
  const isPrevious = direction === "previous";

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-xs"
      className="text-muted-foreground hover:text-foreground"
      aria-label={`${isPrevious ? "Focus previous" : "Focus next"} instance for ${tagLabel}`}
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
    >
      {isPrevious ? (
        <ChevronLeft className="size-3" />
      ) : (
        <ChevronRight className="size-3" />
      )}
    </Button>
  );
}
